<template>
  <div id="app">
    <keep-alive>
      <router-view v-if='$route.meta.keepAlive'></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import store from './store'
export default {
  mounted() {
    if(!store.state.jumpUrl){
      store.commit("updataJumpUrl", window.location.href);
    }
  }
}
</script>
<style>
#app {
  font-family: "Helvetica";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.icp_info p {
  margin: 0;
}
#nav {
  padding: 30px;
}
::-webkit-scrollbar { 
  display: none; 
  width: 0; 
  height: 0; 
  color: transparent; 
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
img{
  object-fit: cover;
}
</style>
